import { Capacitor } from '@capacitor/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Filesystem } from '@capacitor/filesystem';

const isNative = () => {
  try { return Capacitor?.isNativePlatform?.() === true; } catch { return false; }
};

async function base64ToBlob(base64Data, contentType = 'image/jpeg') {
  const sliceSize = 1024;
  const byteCharacters = atob(base64Data);
  const bytesLength = byteCharacters.length;
  const slicesCount = Math.ceil(bytesLength / sliceSize);
  const byteArrays = new Array(slicesCount);

  for (let sliceIndex = 0; sliceIndex < slicesCount; sliceIndex++) {
    const begin = sliceIndex * sliceSize;
    const end = Math.min(begin + sliceSize, bytesLength);

    const bytes = new Array(end - begin);
    for (let offset = begin, i = 0; offset < end; offset++, i++) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type: contentType });
}

export const CameraService = {
  async capturePhoto(options = { source: 'camera' }) {
    if (isNative()) {
      const source = options.source === 'gallery' ? CameraSource.Photos : CameraSource.Camera;
      const photo = await Camera.getPhoto({
        quality: 80,
        resultType: CameraResultType.Uri,
        source,
        saveToGallery: false
      });

      if (photo?.path) {
        // Read file to base64
        const file = await Filesystem.readFile({ path: photo.path });
        const mime = photo.format ? `image/${photo.format}` : 'image/jpeg';
        const blob = await base64ToBlob(file.data, mime);
        const fileName = `capture_${Date.now()}.${photo.format || 'jpg'}`;
        const fileObj = new File([blob], fileName, { type: mime });
        return fileObj;
      }

      if (photo?.webPath) {
        const res = await fetch(photo.webPath);
        const blob = await res.blob();
        const fileName = `capture_${Date.now()}.jpg`;
        return new File([blob], fileName, { type: blob.type || 'image/jpeg' });
      }

      throw new Error('Failed to capture photo');
    }

    // Web fallback: let UI call getUserMedia separately; here we do nothing
    throw new Error('CameraService capturePhoto is only for native; use web camera UI on web');
  }
};


